// направление добавления уведомлений
export const NotificationDirections = Object.freeze({
  DOWMN_PUSH: 'down-push',
  DOWN_STACK: 'down-stack',
  UP_PUSH: 'up-push',
  LEFT_PUSH: 'left-push',
  LEFT_STACK: 'left-stack',
  RIGHT_PUSH: 'right-push',
  RIGHT_STACK: 'right-stack'
})

// позиционирование уведомлений
export const NotificationPositions = Object.freeze({
  TOP_LEFT: 'top left',
  TOP_CENTER: 'top center',
  TOP_RIGHT: 'top right',
  BOTTOM_LEFT: 'bottom left',
  BOTTOM_CENTER: 'bottom center',
  BOTTOM_RIGHT: 'bottom right',
  LEFT_CENTER: 'left center',
  CENTER: 'center',
  RIGHT_CENTER: 'right center'
})

// типы уведомлений
export const NotificationTypes = Object.freeze({
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
})

// продолжительность уведомлений
export const NotificationDurations = Object.freeze({
  DEFAULT: 3000,
  ERROR: 10000,
  WARNING: 5000,
  SUCCESS: 3000,
  INFO: 3000
})